export const getColor = (method: string) => {
  switch (method) {
    case 'GET':
      return 'bg-inpay-green-primary-mixes-80%-secondary';
    case 'DELETE':
      return 'bg-inpay-red-800';
    case 'POST':
      return 'bg-inpay-purple-1000';
    default:
      return 'bg-inpay-gray-primary-1000';
  }
};
